module.exports = __webpack_public_path__ + "static/media/followers.403ade51.svg";